export const facebook_app_id = '292906342633883'

const facebook = {
  name: 'Facebook',
  icon: require(`@/assets/images/common/icon/facebook.png`),
  id: 'facebook',
  className: 'share-logo facebook',
}
const twitter = {
  name: 'Twitter',
  icon: require(`@/assets/images/common/icon/twitter.png`),
  id: 'twitter',
  className: 'share-logo twitter',
}
const whatsapp = {
  name: 'WhatsApp',
  icon: require(`@/assets/images/common/icon/whatsapp.png`),
  id: 'whatsapp',
  className: 'share-logo whatsapp',
}
const messenger = {
  name: 'Messenger',
  icon: require(`@/assets/images/common/icon/messenger.png`),
  id: 'messenger',
  className: 'share-logo messenger',
}

const email = {
  name: 'Email',
  icon: require(`@/assets/images/common/icon/email.png`),
  id: 'email',
  className: 'share-logo email',
}

const vk = {
  name: 'VK',
  icon: require(`@/assets/images/common/icon/vk-c.png`),
  id: 'vk',
  className: 'share-logo vk',
}

const telegram = {
  name: 'Telegram',
  icon: require(`@/assets/images/common/icon/telegram.png`),
  id: 'telegram',
  className: 'share-logo telegram',
}

const copyLink = (text) => {
  return {
    name: text,
    id: 'copyLink',
    icon: require(`@/assets/images/common/icon/link.png`),
    className: 'share-logo copy-link',
  }
}

export const desktop_share_items = [
  facebook,
  twitter,
  whatsapp,
  messenger,
  email,
  vk,
  telegram,
]

export const shareConfigs = {
  facebook,
  twitter,
  whatsapp,
  messenger,
  email,
  vk,
  telegram,
  copyLink,
}
